import _ from 'lodash';
import stepMixin from "../../../../../../utils/mixins/stepMixin.js";
import { GET_BOOKING_TOTAL_PRICE } from "../../../../../../store/booking/getter-types";
import { slugify } from "../../../../../../utils/strings";
import { FETCH_PLACE } from "../../../../../../store/destinies/action-types";
import { GET_DESTINIES } from "../../../../../../store/destinies/getter-types";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [stepMixin],
  data: () => ({
    location: {}
  }),
  computed: {
    ...mapGetters({
      destinies: GET_DESTINIES
    }),
    totalPrice() {
      return this.$store.getters[GET_BOOKING_TOTAL_PRICE];
    },
    formattedDate() {
      const momentDate = this.$store.state.booking.outgoingFlight.departure.datetime;
      return _.capitalize(momentDate.format('dddd DD [de] MMMM'));
    },
    hoursInDestination() {
      const arrival = this.$store.state.booking.outgoingFlight.arrival.datetime;
      const departure = this.$store.state.booking.returnFlight.departure.datetime;
      return departure.diff(arrival, "hours");
    }
  },

  created: function() {
    this.fetchPlace(slugify(this.booking.outgoingFlight.arrival.name));
  },
  methods: {
    submitStep() {
      this.stepComplete(this.activeStep);
    },
    ...mapActions({
      fetchPlace: FETCH_PLACE
    })
  }
};
